<mat-dialog-content style="padding: 24px; background-color: #f9fafb">
  <div style="display: flex; gap: 24px; width: 100%">
    <div style="display: flex; flex-direction: column; gap: 24px; width: 40%">
      <div
        style="
          background-color: white;
          padding: 24px;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
        "
      >
        <h3
          style="
            font-size: 18px;
            font-weight: 600;
            margin-top: 0;
            margin-bottom: 20px;
            border-bottom: 1px solid #e5e7eb;
            padding-bottom: 16px;
          "
        >
          Detalles del Egreso
        </h3>
        <form [formGroup]="additionalOutflowForm">
          <div style="display: flex; flex-direction: column; gap: 16px">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Usuario</mat-label>
              <input
                matInput
                formControlName="username"
                placeholder="Email del usuario"
                readonly
              />
              <mat-error
                *ngIf="additionalOutflowForm.get('username')?.hasError('email')"
              >
                Ingresa un email válido
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Fecha de Egreso</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="outflowDate"
                placeholder="Selecciona la fecha"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error
                *ngIf="
                  additionalOutflowForm.get('outflowDate')?.hasError('required')
                "
              >
                La fecha de egreso es requerida
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Tipo de Egreso</mat-label>
              <mat-select
                formControlName="outflowType"
                placeholder="Selecciona el tipo"
              >
                <mat-option value="" disabled selected>
                  Selecciona un tipo de egreso
                </mat-option>
                <mat-option value="SALIDA POR VENCIMIENTO"
                  >Salida por Vencimiento</mat-option
                >
                <mat-option value="SALIDA POR DETERIORO"
                  >Salida por Deterioro</mat-option
                >
                <mat-option value="SALIDA POR CONSUMO"
                  >Salida por Consumo</mat-option
                >
                <mat-option value="SALIDA POR OTRO MOTIVO"
                  >Salida por Otro Motivo</mat-option
                >
              </mat-select>
              <mat-error
                *ngIf="
                  additionalOutflowForm.get('outflowType')?.hasError('required')
                "
              >
                El tipo de egreso es requerido
              </mat-error>
              <mat-error
                *ngIf="
                  additionalOutflowForm.get('outflowType')?.hasError('pattern')
                "
              >
                Seleccione un tipo de egreso válido
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Observación (Opcional)</mat-label>
              <textarea
                matInput
                formControlName="observation"
                rows="3"
                placeholder="Observación (opcional)"
                maxlength="255"
              ></textarea>
              <mat-hint align="end"
                >{{
                  additionalOutflowForm.get('observation')?.value?.length || 0
                }}/255</mat-hint
              >
              <mat-error
                *ngIf="
                  additionalOutflowForm
                    .get('observation')
                    ?.hasError('maxlength')
                "
              >
                La observación no puede exceder los 255 caracteres
              </mat-error>
            </mat-form-field>
          </div>
        </form>
      </div>

      <div
        *ngIf="selectedFoodItemsDataSource.length > 0"
        style="
          height: 325px;
          background-color: white;
          padding: 24px;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          overflow-y: auto;
        "
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
          "
        >
          <h3 style="font-size: 16px; font-weight: 600; margin: 0">
            Insumos seleccionados ({{ selectedFoodItemsDataSource.length }})
          </h3>
          <button
            type="button"
            mat-button
            (click)="clearAllSelectedItems()"
            style="color: #e95a1a; font-size: 12px; min-width: auto"
          >
            Limpiar Todo
          </button>
        </div>
        <div
          style="
            margin-top: 12px;
            border-radius: 6px;
            overflow: hidden;
            border: 1px solid #e5e7eb;
            background-color: white;
          "
        >
          <div
            *ngFor="
              let item of selectedFoodItemsDataSource;
              trackBy: trackByFoodItemId
            "
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 12px 16px;
              border-bottom: 1px solid #f3f4f6;
              transition: background-color 0.2s ease;
            "
          >
            <div style="flex: 1; min-width: 0; margin-right: 12px">
              <div
                style="
                  font-weight: 600;
                  color: #111827;
                  font-size: 15px;
                  margin-bottom: 4px;
                  line-height: 1.4;
                "
                [title]="item.nombreInsumo"
              >
                {{ item.nombreInsumo }}
              </div>
              <div style="font-size: 12px; color: #6b7280">
                Stock disponible: {{ item?.stock | number: '1.2-2' }}
              </div>
            </div>

            <div
              style="
                display: flex;
                flex-direction: column;
                gap: 8px;
                flex-shrink: 0;
                width: 200px;
              "
            >
              <div style="display: flex; align-items: center; gap: 8px">
                <label
                  style="
                    font-size: 12px;
                    color: #6b7280;
                    font-weight: 500;
                    white-space: nowrap;
                  "
                  >Cantidad:</label
                >
                <div style="display: flex; align-items: center; gap: 4px">
                  <input
                    type="number"
                    [(ngModel)]="item.quantity"
                    (change)="updateQuantity(item, $event)"
                    min="0"
                    [max]="item?.stock || 1"
                    style="
                      width: 60px;
                      height: 32px;
                      padding: 4px 8px;
                      border: 1px solid #d1d5db;
                      border-radius: 4px;
                      text-align: center;
                      font-weight: 600;
                      font-size: 13px;
                      background-color: white;
                      transition: border-color 0.2s ease;
                    "
                    onfocus="this.style.borderColor = '#e95a1a'; this.style.boxShadow = '0 0 0 1px #e95a1a'"
                    onblur="this.style.borderColor = '#d1d5db'; this.style.boxShadow = 'none'"
                  />
                  <span
                    style="
                      font-size: 12px;
                      color: #374151;
                      font-weight: 600;
                      white-space: nowrap;
                    "
                    >{{ item.unidadMedida }}</span
                  >
                </div>
                <button
                  mat-icon-button
                  (click)="removeSelectedItem(item)"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 32px;
                    height: 32px;
                    min-width: 32px;
                    background-color: #fef2f2;
                    color: #dc2626;
                    border-radius: 4px;
                    transition: all 0.2s ease;
                  "
                  onmouseenter="this.style.backgroundColor = '#fee2e2'; this.style.color = '#b91c1c'"
                  onmouseleave="this.style.backgroundColor = '#fef2f2'; this.style.color = '#dc2626'"
                >
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px"
                    >delete</mat-icon
                  >
                </button>
              </div>

              <div style="display: flex; flex-direction: column; gap: 4px">
                <label style="font-size: 12px; color: #6b7280; font-weight: 500"
                  >Observación*:</label
                >
                <input
                  type="text"
                  [(ngModel)]="item.observation"
                  (change)="updateObservation(item, $event)"
                  placeholder="Observación requerida"
                  maxlength="255"
                  style="
                    width: 100%;
                    height: 32px;
                    padding: 4px 8px;
                    border: 1px solid #d1d5db;
                    border-radius: 4px;
                    font-size: 13px;
                    background-color: white;
                    transition: border-color 0.2s ease;
                  "
                  [style.border-color]="
                    !item.observation || item.observation.trim() === ''
                      ? '#dc2626'
                      : '#d1d5db'
                  "
                  onfocus="this.style.borderColor = '#e95a1a'; this.style.boxShadow = '0 0 0 1px #e95a1a'"
                  onblur="this.style.borderColor = this.value.trim() === '' ? '#dc2626' : '#d1d5db'; this.style.boxShadow = 'none'"
                />
                <div
                  *ngIf="!item.observation || item.observation.trim() === ''"
                  style="font-size: 11px; color: #dc2626; margin-top: 2px"
                >
                  La observación es requerida
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="selectedFoodItemsDataSource.length === 0"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 32px 16px;
              text-align: center;
              color: #9ca3af;
            "
          >
            <mat-icon style="font-size: 32px; margin-bottom: 8px"
              >inventory_2</mat-icon
            >
            <p style="margin: 0; font-size: 13px; color: #6b7280">
              No hay insumos seleccionados
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        background-color: white;
        padding: 24px;
        border-radius: 8px;
        border: 1px solid #e5e7eb;
        width: 60%;
      "
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        "
      >
        <h3 style="font-size: 18px; font-weight: 600; margin: 0">
          Seleccionar Insumos
          <span
            *ngIf="selectedFoodItemsDataSource.length > 0"
            style="font-size: 14px; font-weight: 500; color: #e95a1a"
          >
            ({{ selectedFoodItemsDataSource.length }} seleccionados)
          </span>
        </h3>
        <mat-form-field
          appearance="outline"
          style="width: 300px; font-size: 14px"
        >
          <input
            matInput
            (keyup)="applyFilter($event)"
            placeholder="Buscar insumos..."
          />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>

      <div
        *ngIf="isLoadingWarehouse"
        style="
          width: 100%;
          height: 300px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>

      <div
        *ngIf="!isLoadingWarehouse"
        style="
          width: 100%;
          overflow-x: auto;
          overflow-y: auto;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          background: white;
        "
        tabindex="0"
      >
        <div
          style="width: 100%; overflow-x: auto; overflow-y: auto; height: 600px"
        >
          <table
            mat-table
            [dataSource]="dataSource"
            id="food-items-table"
            matSort
            multiTemplateDataRows
            style="width: 100%"
          >
            <ng-container matColumnDef="checkbox">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="width: 50px; padding: 8px 12px"
              ></th>
              <td
                mat-cell
                *matCellDef="let foodItem"
                style="width: 50px; padding: 8px 12px"
              >
                <mat-checkbox
                  color="primary"
                  [checked]="foodItem.checked"
                  (change)="updateCheck(foodItem)"
                >
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="nombre-insumo">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                style="width: 40%; padding: 8px 16px"
              >
                Nombre Insumo
              </th>
              <td
                mat-cell
                *matCellDef="let foodItem"
                style="width: 40%; padding: 8px 16px"
              >
                <span
                  style="font-weight: 500; color: #111827; font-size: 14px"
                  >{{ foodItem?.nombreInsumo }}</span
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="stock">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                style="width: 15%; padding: 8px 12px"
              >
                Stock
              </th>
              <td
                mat-cell
                *matCellDef="let foodItem"
                style="width: 15%; padding: 8px 12px"
              >
                <span
                  style="font-weight: 500; color: #374151; font-size: 13px"
                  >{{ foodItem?.stock | number: '1.2-2' }}</span
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="unidad-medida">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="width: 10%; padding: 8px 12px"
              >
                Unidad
              </th>
              <td
                mat-cell
                *matCellDef="let foodItem"
                style="width: 10%; padding: 8px 12px"
              >
                <span
                  style="
                    background-color: #f3f4f6;
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-size: 11px;
                    font-weight: 600;
                    color: #374151;
                  "
                  >{{ foodItem?.unidadMedida }}</span
                >
              </td>
            </ng-container>

            <!-- <ng-container matColumnDef="precio-referencial">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              style="width: 15%; padding: 8px 12px"
            >
              Precio Ref.
            </th>
            <td
              mat-cell
              *matCellDef="let foodItem"
              style="width: 15%; padding: 8px 12px"
            >
              <span style="font-weight: 500; color: #374151; font-size: 13px">{{
                foodItem?.precioReferencial | number: '1.0-1'
              }}</span>
            </td>
          </ng-container> -->

            <ng-container matColumnDef="peso">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                style="width: 15%; padding: 8px 12px"
              >
                Peso
              </th>
              <td
                mat-cell
                *matCellDef="let foodItem"
                style="width: 15%; padding: 8px 12px"
              >
                <span
                  style="font-weight: 500; color: #374151; font-size: 13px"
                  >{{ foodItem?.peso | number: '1.2-2' }}</span
                >
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"
              style="background-color: #f8f9fa; font-weight: 600; height: 48px"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              style="
                height: 52px;
                border-bottom: 1px solid #f3f4f6;
                transition: background-color 0.2s ease;
              "
              [class.selected-row]="row.checked"
            ></tr>
          </table>
        </div>
        <div [hidden]="isLoadingWarehouse" style="border-radius: 8px">
          <mat-paginator
            [pageSizeOptions]="[10, 25, 50]"
            style="background: transparent"
            aria-label="Elige la página de insumos del almacén"
          ></mat-paginator>
        </div>
        <div
          *ngIf="dataSource.filteredData.length === 0"
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 48px 24px;
            text-align: center;
            color: #6b7280;
          "
        >
          <mat-icon style="font-size: 48px; color: #d1d5db; margin-bottom: 16px"
            >search_off</mat-icon
          >
          <p
            style="
              margin: 0 0 8px 0;
              font-size: 14px;
              font-weight: 500;
              color: #374151;
            "
          >
            No se encontraron insumos que coincidan con la búsqueda
          </p>
          <small style="font-size: 12px; color: #9ca3af"
            >Intenta con otros términos de búsqueda</small
          >
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 16px 24px">
  <button mat-stroked-button mat-dialog-close>Cancelar</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="
      !additionalOutflowForm.valid ||
      selectedFoodItemsDataSource.length === 0 ||
      !areAllObservationsValid()
    "
    (click)="createAdditionalOutflow()"
  >
    Guardar Egreso
  </button>
</mat-dialog-actions>
